module.exports = __webpack_public_path__ + "img/sort-down-solid.a56f3c0.svg";